const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/dateTime/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        minutes: '{minutes, plural, =1 {1 Minute} other {# Minuten}}',
        hours: '{hours, plural, =1 {1 Stunde} other {# Std.}}',
        'hoursAndMinutes.OneOne': '1 Stunde und 1 Minute',
        'hoursAndMinutes.OneMany': '{hours} Stunde und {minutes} Minuten',
        'hoursAndMinutes.ManyOne': '{hours} Std. und {minutes} Minute',
        'hoursAndMinutes.ManyMany': '{hours} Std. und {minutes} Minuten',
        stopBeforeStartError: 'Enddatum muss nach dem Startdatum liegen.',
    },
    __RELATIVE_SOURCE_FILE__
);
